<script>
  import {reset_url, update_video} from "./Utils/RouterUtils.svelte"
  import {search_store, active_video_store, normalized_video_store} from "./Utils/stores";
  import {store} from "./Utils/stores";
  import Debug from "./Utils/Debug.svelte";
  import VideoPlayerModal from "./VideoPlayerModal.svelte";
  import SingleVideoTile from "./SingleVideoTile.svelte";


  function handleVideoClick(video) {
    update_video(video)
  }
</script>

{#if $active_video_store.active_video !== null}
<!--  <VideoPlayerModal video={$active_video_store.active_video} playlist={$active_video_store.active_playlist}/>-->
{/if}


<div class="vec-my-5 vec-px-5">
  <div class="flex vec-mb-5">
    <p class="vec-text-sm vec-cursor-pointer"><a on:click={reset_url}>Tutorials</a> &nbsp; &gt; &nbsp; Search &nbsp; &gt; &nbsp; {$store.search}
    </p>
  </div>
  <div class="vec-flex vec-flex-col">
    <div class="vec-flex vec-flex-col">
      <h2 class="vec-mb-5">Search Results for <em class="font-normal">{$store.search}</em></h2>
    </div>
    <div class="vec-flex vec-flex-col pt-5">
      {#if $search_store.results.length == 0 && !$search_store.searching}
        <div class="vec-text-2xl text-center vec-italic ">
          No videos found matching {$store.search}
        </div>
      {:else}
        <div class="vec-grid vec-grid-cols-1 sm:vec-grid-cols-2 md:vec-grid-cols-3 vec-gap-6">
          {#each $search_store.results as video_slug (video_slug.slug)}
            <SingleVideoTile video={$normalized_video_store.videos[video_slug.slug]}
                             on:click={() => handleVideoClick(video_slug.slug)}/>
          {/each}
        </div>
        {/if}
    </div>
  </div>
</div>
